import { Link, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material';
import { useState } from 'react';
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom';

interface ListTooltipProps {
  parent?: string;
  canAccessAllWorkItems?: boolean;
  wave4?: boolean;
  tabIndex?: number;
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: theme.typography.pxToRem(12)
  },
}));

const ParentWorkItemListTooltip = ( props : ListTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const list = props.parent?.split("\n");

  const wave4 = props.wave4 ?? false;

  const handleTooltipOpen = () => {
    setShowTooltip(true);
  };

  const handleTooltipClose = () => {
    setShowTooltip(false);
  };

  return (
    <HtmlTooltip
      placement='top-start'
      arrow
      title={
        <ul style={{padding: '0 8px', marginBlockStart: 0, marginBlockEnd: 0}}>
          {list?.map((item, key) => {
            const regex = /\((\d+)\)/;
            const match = regex.exec(item);
            let workItemId = null;
            if (match) {
              workItemId = match[1];
            }

            const workitemEditUrl = wave4 
              ? `/workitems/${workItemId}`
              : process.env.REACT_APP_PUBLIC_URL + `/workitems/${workItemId}/overview`;

            return(
              <li key={item} style={{listStylePosition: 'inside', textDecoration: 'none'}}>
                {props.canAccessAllWorkItems  ? 
                  <Link component={RouterLink} to={workitemEditUrl} tabIndex={props.tabIndex} sx={{color: 'white', fontSize:'12px'}}>
                    {item}
                  </Link>
                : <>{item}</> }
              </li>
            )
          })}
        </ul>
      }
      open={showTooltip}
      onClose={handleTooltipClose}
      disableFocusListener
      disableHoverListener={!list?.length}
      disableTouchListener={!list?.length}
    >
      <Typography
        onMouseEnter={handleTooltipOpen}
      >
        {list && list?.length >= 1 && 
          list?.map((item, key) => {
            const regex = /\((\d+)\)/;
            const match = regex.exec(item);
            let workItemId = null;
            if (match) {
              workItemId = match[1];
            }
            const workitemEditUrl = wave4 
              ? `/workitems/${workItemId}`
              : process.env.REACT_APP_PUBLIC_URL + `/workitems/${workItemId}/overview`;
            return (
              <span key={key}>                
                {props.canAccessAllWorkItems  ? 
                <Link component={RouterLink} to={workitemEditUrl} tabIndex={props.tabIndex} sx={{fontSize:'14px'}}>
                  {item}
                </Link>
                : <>{item}</>}
                {key !== list.length - 1 && ' | '}
              </span>
            );
          })
        }
      </Typography>
    </HtmlTooltip>
  );
};
export default ParentWorkItemListTooltip;